import styled from "styled-components";
import React from "react";
import {Flex} from "../StyleComponents";

const PostStyled = styled(Flex)`
    font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
    max-width: 600px;
    margin: 0px auto;
    // flex-direction: ${(props: any) => (props.size === 'Large') ? "column" : "row"};
    background-color: ${(props: any) => props.isBgGray ? '#f0f0f0' : 'transparent'};
    padding: 14px;
    
    a{
    text-decoration: none;
    color:black;
    }
    img{
    max-width: ${(props: any) => (props.size === 'Large') ? "560px" : "277px"};
    }
`;
const Table = styled.table`
font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
text-align: right;
float: ${(props: any) => (props.size === 'Large') ? "none" : "right"};
 width:  ${(props: any) => (props.size === 'Large') ? "100%" : "50%"};
 
 td.text{
      padding-right: ${(props: any) => (props.size === 'Large') ? "0" : "10px"};
      
      h3{margin-top: 0;}
 }
`;

const Post = (props: any) => {

    const post = props.data.post || {};

    let {
        image_src,
        post_title,
        post_excerpt,
        snippet,
        guid,
        // post_content,
    } = post;

    post_excerpt = post_excerpt && post_excerpt.trim();

    // if (process.env.NODE_ENV !== 'production') {
        snippet = snippet && snippet.trim();
        post_excerpt = (post_excerpt && post_excerpt !== '') ? post_excerpt : (snippet && snippet !== '' ? snippet : undefined);

        if (image_src) {
            image_src = image_src.replace('clarionproject', 'clarionproject.org');
            image_src = image_src.replace('giladt', 'medialab.jerusalemu.org');
            image_src = image_src.replace('localhost', 'medialab.jerusalemu.org');
        }
    // }


    return (
        <PostStyled {...props}>
            <table style={{border: 0, width: '100%',maxWidth:600,}}>
                <tbody>
                <tr>
                    <td>
                        <Table {...props}>
                            <tbody>
                            <tr>
                                <td>
                                    <img alt={post_title}
                                         src={image_src || (process.env.NODE_ENV !== 'production' ? '/images/Image_placeholder_293.jpg' : '/wp-content/plugins/wp-campaigns/admin/partials/build/images/Image_placeholder_293.jpg')}
                                         width="100%"/>
                                </td>
                            </tr>
                            </tbody>
                        </Table>
                        <Table {...props}>
                            <tbody>
                            <tr>
                                <td className={'text'}>
                                    <h3 style={{marginBottom: 0}}>
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={guid || '#'}>{post_title || 'What is Lorem Ipsum?'}</a>
                                    </h3>
                                    <br/>
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={guid || '#'}>{post_excerpt || 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'}</a>

                                </td>
                            </tr>
                            </tbody>
                        </Table>
                    </td>
                </tr>
                </tbody>
            </table>
        </PostStyled>
    );
};

export default Post;
